import type { FilterState } from "@/types/comic";
import { regions, sortOptions, statusOptions, tagOptions } from "@/utils/comics";

interface FilterPanelProps {
  filters: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
}

interface GroupProps {
  title: string;
  options: string[];
  value: string;
  onSelect: (value: string) => void;
}

function FilterGroup({ title, options, value, onSelect }: GroupProps) {
  return (
    <div>
      <h4 className="mb-2 font-heading text-xs font-semibold uppercase tracking-[0.12em] text-foreground-500">
        {title}
      </h4>
      <div className="flex flex-wrap gap-1.5">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onSelect(option)}
            className={`whitespace-nowrap rounded-md border px-2.5 py-1.5 text-xs font-medium transition-colors ${
              value === option
                ? "border-primary-500 bg-primary-500 text-background-50"
                : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ filters, onChange, onReset }: FilterPanelProps) {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-1.5 font-heading text-sm font-bold text-foreground-950">
          <i className="ri-filter-3-line text-base text-primary-500"></i>
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 whitespace-nowrap text-[11px] font-medium text-foreground-500 transition-colors hover:text-primary-700"
        >
          <i className="ri-refresh-line"></i>
          重置
        </button>
      </div>

      <FilterGroup
        title="题材标签"
        options={tagOptions}
        value={filters.tag}
        onSelect={(tag) => onChange({ ...filters, tag })}
      />
      <FilterGroup
        title="地区"
        options={regions}
        value={filters.region}
        onSelect={(region) => onChange({ ...filters, region })}
      />
      <FilterGroup
        title="连载状态"
        options={statusOptions}
        value={filters.status}
        onSelect={(status) => onChange({ ...filters, status })}
      />
      <FilterGroup
        title="排序方式"
        options={sortOptions}
        value={filters.sort}
        onSelect={(sort) => onChange({ ...filters, sort })}
      />
    </div>
  );
}